
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/aa568cf92ccd7a005904ca03030841e2.jpg"
          alt="Fishing Action"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        {/* Main Headline */}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-white mb-6 tracking-tight leading-none">
          BUILT FOR THE
          <br />
          <span className="text-cyan-400">WATER</span>
        </h1>

        {/* Subheadline */}
        <p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-3xl mx-auto font-light">
          Premium Fishing Gear & Apparel for Serious Anglers
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <a
            href="/products"
            className="bg-cyan-600 text-white px-10 py-4 rounded-md text-lg font-bold hover:bg-cyan-700 transition-all cursor-pointer whitespace-nowrap uppercase tracking-wider shadow-xl hover:shadow-2xl transform hover:scale-105"
          >
            Shop Now
          </a>
          <a
            href="#about"
            className="bg-white/10 backdrop-blur-sm text-white border-2 border-white px-10 py-4 rounded-md text-lg font-bold hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap uppercase tracking-wider"
          >
            Learn More
          </a>
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-wrap items-center justify-center gap-8 text-white/90">
          <div className="flex items-center space-x-2">
            <i className="ri-shield-check-line text-2xl w-6 h-6 flex items-center justify-center text-cyan-400"></i>
            <span className="text-sm font-semibold uppercase tracking-wider">Premium Quality</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-truck-line text-2xl w-6 h-6 flex items-center justify-center text-cyan-400"></i>
            <span className="text-sm font-semibold uppercase tracking-wider">Free Shipping</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-customer-service-2-line text-2xl w-6 h-6 flex items-center justify-center text-cyan-400"></i>
            <span className="text-sm font-semibold uppercase tracking-wider">24/7 Support</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/70 w-8 h-8 flex items-center justify-center"></i>
      </div>
    </section>
  );
}
